import { useState } from "react";

export const useRidePreview = () => {
    const [rideOpen, setRideOpen] = useState(false);
    const [rideUrl, setRideUrl] = useState(null);

    // ✅ AHORA RECIBE SOLO LA URL
    const openRidePreview = (url) => {
        if (!url) return;
        setRideUrl(url);
        setRideOpen(true);
    };

    const closeRidePreview = () => {
        setRideOpen(false);
        setRideUrl(null);
    };

    return {
        rideOpen,
        rideUrl,
        openRidePreview,
        closeRidePreview,
    };
};
